module.exports = __webpack_public_path__ + "static/media/lens2_big_grayzel.4afe6bb7.png";